import { render, staticRenderFns } from "./CategoriesInput.vue?vue&type=template&id=442d83a5&scoped=true&"
import script from "./CategoriesInput.vue?vue&type=script&lang=ts&"
export * from "./CategoriesInput.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriesInput.vue?vue&type=style&index=0&id=442d83a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d83a5",
  null
  
)

export default component.exports